<template>
  <div class="container">
    <div class="txt">{{ $t('finance').simFinanceTips }}</div>
    <TabBar :active="'FinanceSim'" />
  </div>
</template>

<script>
import TabBar from '@/components/tabBar'

export default {
  components: {
    TabBar,
  },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  display: flex;
  align-items: center;
  justify-content: center;
  .txt {
    padding: 0 15px;
    font-size: 15px;
    color: var(--text_color);
  }
}
</style>
